import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

/* A block with its own rung's line height, so the gap a field's stack puts
   under it (`space-y-*`, `gap-*`) is the gap you see. An inline label took
   no vertical margin at all under Tailwind 4's `space-y`, and its line box
   was the PARENT's, which is where the extra 3px under it came from. */
const labelVariants = cva(
  "block text-label font-semibold text-foreground/80 peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
)

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
